<template>
  <div id="app">
    <router-view v-if="!badNavigator" :key="$route.fullPath"></router-view>
    <bad-navigator v-else></bad-navigator>
  </div>
</template>

<script>
import api from "./api";
import BadNavigator from "@/components/BadNavigator.vue";
export default {
  components: {
    BadNavigator
  },
  data() {
    return {
      badNavigator: false
    };
  },
  created() {
    this.$i18n.set("en");
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    if (isIE) {
      this.badNavigator = true;
    }
    if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
      this.$store.commit("firefox");
    }
  },
  mounted() {
    window.addEventListener("touchstart", function onFirstTouch() {
      document.body.classList.add("touch-device");
      window.removeEventListener("touchstart", onFirstTouch, false);
    });
  }
};
</script>

<style lang="scss">
</style>
